import { Breakpoint, Breakpoints } from "./types";

export const NOTIFICATIONS_AUTO_CLOSE_DEFAULT_DELAY = 5000;

/**
 * These are the Text Template Keys used internally by Blueprint components.
 *
 * Text templates for these keys must be provided by the consuming applications.
 */
export const BDS_TEXT_TEMPLATE_KEYS = {
  BDS_NUMBER_INPUT_PLUS_BUTTON_LABEL: "BDS_NUMBER_INPUT_PLUS_BUTTON_LABEL",
  BDS_NUMBER_INPUT_MINUS_BUTTON_LABEL: "BDS_NUMBER_INPUT_MINUS_BUTTON_LABEL",

  BDS_SCROLL_TO_TOP_BUTTON_LABEL: "BDS_SCROLL_TO_TOP_BUTTON_LABEL",

  BDS_BREADCRUMBS_BACK_BUTTON_LABEL: "BDS_BREADCRUMBS_BACK_BUTTON_LABEL",

  BDS_PAGINATION_ITEMS_PER_PAGE: "BDS_PAGINATION_ITEMS_PER_PAGE",
  BDS_PAGINATION_PREVIOUS_PAGE: "BDS_PAGINATION_PREVIOUS_PAGE",
  BDS_PAGINATION_NEXT_PAGE: "BDS_PAGINATION_NEXT_PAGE",
  BDS_PAGINATION_OF_ITEMS: "BDS_PAGINATION_OF_ITEMS",
  BDS_PAGINATION_PAGE: "BDS_PAGINATION_PAGE",
  BDS_PAGINATION_ITEMS: "BDS_PAGINATION_ITEMS",
  BDS_PAGINATION_VIEW_ALL_ITEMS: "BDS_PAGINATION_VIEW_ALL_ITEMS",

  BDS_RATING_STATS_POPOVER_BUTTON_LABEL: "BDS_RATING_STATS_POPOVER_BUTTON_LABEL",
  BDS_RATING_STATS_SEE_ALL_REVIEWS_LINK_TEXT: "BDS_RATING_STATS_SEE_ALL_REVIEWS_LINK_TEXT",
  BDS_RATING_STAT_AVERAGE_RATING_LABEL_TEXT: "BDS_RATING_STAT_AVERAGE_RATING_LABEL_TEXT",
  BDS_RATING_STAT_TOTAL_REVIEWS_LABEL_TEXT: "BDS_RATING_STAT_TOTAL_REVIEWS_LABEL_TEXT",

  BDS_MESSAGE_INFO: "BDS_MESSAGE_INFO",
  BDS_MESSAGE_SUCCESS: "BDS_MESSAGE_SUCCESS",
  BDS_MESSAGE_ERROR: "BDS_MESSAGE_ERROR",
  BDS_MESSAGE_WARNING: "BDS_MESSAGE_WARNING",
};

export const BDS_NUMBER_INPUT_PLUS_BUTTON_DEFAULT_LABEL = "Plus";

export const BDS_NUMBER_INPUT_MINUS_BUTTON_DEFAULT_LABEL = "Minus";

export const BDS_SCROLL_TO_TOP_BUTTON_DEFAULT_LABEL = "Back to Top";

export const BDS_BREADCRUMBS_BACK_BUTTON_DEFAULT_LABEL = "Back";

export const BDS_PAGINATION_ITEMS_PER_PAGE_DEFAULT_TEXT = "Items per page";

export const BDS_PAGINATION_PREVIOUS_PAGE_DEFAULT_TEXT = "Previous page";

export const BDS_PAGINATION_NEXT_PAGE_DEFAULT_TEXT = "Next page";

export const BDS_PAGINATION_TOTAL_ITEMS_PLACEHOLDER = `TOTAL_ITEMS`;

export const BDS_PAGINATION_OF_ITEMS_DEFAULT_TEXT = ` of {${BDS_PAGINATION_TOTAL_ITEMS_PLACEHOLDER}} items`;

export const BDS_PAGINATION_PAGE_DEFAULT_TEXT = "Page";

export const BDS_PAGINATION_ITEMS_DEFAULT_TEXT = "Items";

export const BDS_PAGINATION_VIEW_ALL_ITEMS_DEFAULT_TEXT = "View All Items";

export const BDS_RATING_TOTAL_REVIEWS_PLACEHOLDER = "TOTAL_REVIEWS";

export const BDS_RATING_AVERAGE_RATING_PLACEHOLDER = "AVERAGE_RATING";

export const BDS_RATING_STATS_POPOVER_BUTTON_DEFAULT_LABEL = `{${BDS_RATING_TOTAL_REVIEWS_PLACEHOLDER}} Reviews`;

export const BDS_RATING_STATS_SEE_ALL_REVIEWS_LINK_DEFAULT_TEXT = "See All Reviews";

export const BDS_RATING_STAT_AVERAGE_RATING_LABEL_DEFAULT_TEXT = `{${BDS_RATING_AVERAGE_RATING_PLACEHOLDER}} out of 5 Avg. Rating`;

export const BDS_RATING_STAT_TOTAL_REVIEWS_LABEL_DEFAULT_TEXT = `({${BDS_RATING_TOTAL_REVIEWS_PLACEHOLDER}} Review)`;

export const BDS_MESSAGE_INFO_DEFAULT_TEXT = "Info";

export const BDS_MESSAGE_SUCCESS_DEFAULT_TEXT = "Success";

export const BDS_MESSAGE_ERROR_DEFAULT_TEXT = "Error";

export const BDS_MESSAGE_WARNING_DEFAULT_TEXT = "Warning";

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DAYS = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

/* Screen responsiveness related constants */
export const DEFAULT_BREAKPOINTS: Breakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1366px",
  "3xl": "1660px",
};

export const DEFAULT_DESKTOP_BREAKPOINT: Breakpoint = "lg";

export const TIME_CHANGE_DELAY = 2000;
